import { $,_,Backbone,Foundation } from '../../vendor'
import { Biscuit } from '../utils';
import InboomaBaseController from './InboomaBaseController'

import User from '../models/User'

import UsersSidebarView from '../views/users/UsersSidebarView'
import UsersSortTabs from '../views/users/UsersSortTabs'
import OffCanvasUsersForm from '../views/users/OffCanvasUsersForm'
import UsersCustomerView from '../views/users/UsersCustomerView'
import UsersStaffView from '../views/users/UsersStaffView'

import UsersViewTpl from '../templates/users/UsersTpl.html'
import Users from '../collections/Users';
import { isViewVisible } from '../utils/ViewSettings'

export default InboomaBaseController.extend({

    _channelName: 'users',
    _el: '#inb-c-main-users',
    _template: UsersViewTpl,

    _accessBarMap () {
      return {
        model: User,
        collection: this.collection,
        pageTitle: this.t('users',null,'capital'),
        searchPlaceholder: this.t('username') +' / ID / '+ this.t('e-mail'),
        linksMap: {
          users: { // user role == customers
            url: '/users',
            icon: 'fi fi-address-book',
            isAccessible: isViewVisible('users','users')
          },
          staff: { // user role == admin||manager||manager-location
            url: '/users/staff',
            icon: 'fi fi-torsos-all',
            isAccessible: isViewVisible('staff','users')
            //actionLink: 'read-staff'
          },
          messages: { // view messages list
            url: '/usersExtension/messages',
            icon: 'fi fi-mail',
            isAccessible: isViewVisible('messages','users')
            //actionLink: 'read-staff'
          }
        }
      }
    },

    /** 
     * @routes /users 
     */
    index (staffView = false) {

      // work-around to fix routing issue of leftover overlay(s) (render-issue)
      if (document.location.href.split('/users')[1].length == 0) {
        _.each($('.js-off-canvas-overlay'),(overlay) => {
          $(overlay).removeClass('is-visible');
        });
      }

      if (staffView && typeof staffView.indexOf === 'function' && staffView.indexOf('id=') >= 0) {
        this.usersForm(staffView.slice(3));
        return;
      }
      this._resetOptions();

      if (typeof this._usersView !== 'undefined'
          && typeof this._usersView.unbindEvents == 'function') {
        this._usersView.$el.empty();
        this._usersView.stopListening();
      }

      //this.collection.resetFilters();
        
      if (staffView === true) {

        this._collection.filterByIsEmployee(true);
        this._usersView = new UsersStaffView(
          {  
            collection: this._collection,
            widgetMode: this.widgetMode,
            el: this._el
          }
        )

      } else {

        this._collection.filterByIsEmployee(false);
        this._usersView = new UsersCustomerView(
          { 
            collection: this._collection,
            widgetMode: this.widgetMode,
            el: this._el
          }
        )

      }

      if (!this.widgetMode) {

        this.usersSidebarView = new UsersSidebarView({ collection: this._collection, model: User });
        this.usersSortTabs = new UsersSortTabs({ collection: this._collection, model: User });
  
        $('.inb-filtered-users-count').html(this._collection.models.length);
      }

    },

    /**
     * @routes /users/help
     */
    usersHelp () {

      new Foundation.Reveal($('.inb-users-help-modal')).open();

      $(document).on('closed.zf.reveal', function() {
        Backbone.history.navigate('users');
        $(document).off('closed.zf.reveal');
      });

    },

    /** 
     *  @routes /users/add
     *          /users/:id
     */
    usersForm (id = null) {

      const that = this;
    
      this.index();
      
      if (id === null || id == '') {

        new OffCanvasUsersForm({
          model : new User(),
          collection : this._collection
        });

      } else {

        const RequestHelper = Backbone.Model.extend({ urlRoot : '/users' });

        (new RequestHelper({ id: id })).fetch({                                   // fetch user by id
            success (model, response) {

              let _model = new User();

              _.extend(_model.attributes,model.attributes.data);                  // copy data of model

              new OffCanvasUsersForm({
                model: _.clone(_model),
                collection: that._collection
              });
            },
            error (model, response) {
              alert(that.t('user_not_exist_or_removed'));
            }
          });
/*
        //newCollection.filterById(id);

        //this._collection.filterById(id);
        console.log("collection: ", newCollection);
        var _user = this._collection._byId[id];
        console.log("user: ",_user);
          if (typeof _user !== 'undefined') {

            new OffCanvasUsersForm({
              model : _user,
              collection : that._collection
            });

          } else {
            alert(that.t('user_not_exist_or_removed'));
          }*/
      }
    },

    staff () {

      this.index(true);

    }
   
});